import { render, staticRenderFns } from "./profissionais.vue?vue&type=template&id=805897e6&"
import script from "./profissionais.vue?vue&type=script&lang=js&"
export * from "./profissionais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports